export default "__VITE_ASSET__CGcAc6Nu__"